export default __webpack_public_path__ + "static/media/visamastercard.92533fa9.svg";